import { render, staticRenderFns } from "./WidgetSettingsTab.vue?vue&type=template&id=1295d36e"
import script from "./WidgetSettingsTab.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsTab.vue?vue&type=style&index=0&id=1295d36e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports